import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Api } from "../api/baseApi";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";

function GetDemoForm() {
  const { t } = useTranslation();
  const [message, setMessage] = useState(null);
  const initialValues = {
    fullName: "",
    email: "",
    phone: "",
    organization_name: "",
  };

  const validationSchema = Yup.object({
    fullName: Yup.string().required(t("getDemoForm.errors.fullName")),
    email: Yup.string()
      .email(t("getDemoForm.errors.emailInvalid"))
      .required(t("getDemoForm.errors.emailRequired")),
    phone: Yup.string()
      .matches(/^\+?\d{1,4}?[\d\s-]{5,}$/, t("getDemoForm.errors.phoneInvalid"))
      .required(t("getDemoForm.errors.phoneRequired")),
    organization_name: Yup.string().required(t("getDemoForm.errors.organizationRequired")),
  });

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
        const data = {
            ...values,
            project: 'Nomio'
        }
      const res = await Api.post(`/api/demoMessageSend`, data);

      if (res.data.status){
        setMessage({ status: true, message: t("errorMessages.2") });
      }
      resetForm();
    } catch (error) {
      console.error(error);
    } finally {
      setSubmitting(false);
    }
  };


  useEffect(() => {
      if (message) {
        const timer = setTimeout(() => setMessage(null), 4000);
        return () => clearTimeout(timer);
      }
    }, [message]);

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ isSubmitting }) => (
        <Form className="row gy-4">
          {/* message */}
          {message && <div className={`col-12 ${message?.status ? "text-success" : "text-danger"}`}>{message.message}</div>}
          {/* Full Name */}
          <div className="col-12">
            <label className="form-label mb-2 font-18 font-heading fw-600">
              {t("getDemoForm.labels.fullName")}
            </label>
            <div className="position-relative">
              <Field
                type="text"
                name="fullName"
                className="common-input  common-input--withIcon"
                placeholder={t("getDemoForm.placeholders.fullName")}
              />
              <span className="input-icon">
                                                <img src="/assets/images/icons/user-icon.svg" alt="" />
              </span>
            </div>
            <ErrorMessage name="fullName" component="div" className="text-danger mt-1" />
          </div>

          {/* Email */}
          <div className="col-12">
            <label className="form-label mb-2 font-18 font-heading fw-600">
              {t("getDemoForm.labels.email")}
            </label>
            <div className="position-relative">
              <Field
                type="email"
                name="email"
                className="common-input  common-input--withIcon"
                placeholder={t("getDemoForm.placeholders.email")}
              />
              <span className="input-icon">
                                                <img src="/assets/images/icons/envelope-icon.svg" alt="" />
              </span>
            </div>
            <ErrorMessage name="email" component="div" className="text-danger mt-1" />
          </div>

          {/* Phone */}
          <div className="col-12">
            <label className="form-label mb-2 font-18 font-heading fw-600">
              {t("getDemoForm.labels.phone")}
            </label>
            <div className="position-relative">
              <Field
                type="tel"
                name="phone"
                className="common-input  common-input--withIcon"
                placeholder={t("getDemoForm.placeholders.phone")}
              />
              <span className="input-icon">
                <img src="/assets/images/icons/phone-icon.svg" alt="" />
              </span>
            </div>
            <ErrorMessage name="phone" component="div" className="text-danger mt-1" />
          </div>

          {/* Organization Name */}
          <div className="col-12">
            <label className="form-label mb-2 font-18 font-heading fw-600">
              {t("getDemoForm.labels.organization")}
            </label>
            <div className="position-relative">
              <Field
                type="text"
                name="organization_name"
                className="common-input  common-input--withIcon"
                placeholder={t("getDemoForm.placeholders.organization")}
              />
              <span className="input-icon">
                <img src="/assets/images/icons/building-icon.svg" alt="" />
              </span>
            </div>
            <ErrorMessage
              name="organization_name"
              component="div"
              className="text-danger mt-1"
            />
          </div>

          {/* Submit Button */}
          <div className="col-12">
            <button
              id="demo-form-button"
              type="submit"
              disabled={isSubmitting}
              className="btn btn-main btn-lg w-100 pill"
            >
              {isSubmitting ? t("getDemoForm.labels.btnLoading") : t("getDemoForm.labels.btn")}
            </button>
          </div>
        </Form>
      )}
    </Formik>
  );
}

export default GetDemoForm;

